import { ApolloError, gql, useQuery } from '@apollo/client';
import { IPlansCardResponse } from '../../common/interfaces/Plans';

const GET_PLANS_BY_PT = gql`
    query plansByPt($ptId: ID!){
        plansByPt(ptId: $ptId) {
            _id
            name
            startDate
            endDate
            active
            lastTrainingDate
            lastTrainingNote
            lastTrainingRating
            exercise {
                _id
                recovery
                exercise{
                    _id
                    name
                    howTo
                    muscleGroups{
                        _id
                        muscleGroup{
                            name
                            icon
                        }
                        percentage
                    }
                }
                loads{
                    date
                    set {
                        noSet
                        loadInKg
                    }
                }
                setRep {
                    set
                    rep
                    type
                }
                day
                note
            }
            phase
            owner {
                _id
            }
            days
            caption
            volumes {
                trainingSets
                volume
                muscleGroup {
                    _id
                }
            }
        }
    }
`;

type ControllerFN = (idUser:string | undefined) => {
    plansByPt: IPlansCardResponse[];
    loading: boolean;
    error: ApolloError | undefined
};

export const useGetPlansByPt: ControllerFN = (ptId: string | undefined) => {
  const { data, loading, error } = useQuery(GET_PLANS_BY_PT, {
    variables: { ptId: ptId || '' },
  });

  const plansByPt = data?.plansByPt;
  return { loading, plansByPt, error };
};
